import React, { Fragment, useState, useEffect, useContext } from "react";
import { sFEEColumns } from "../../../Data/Driver/DriverWallet";
import CommonDataTable from "../../Common/Component/CommonDataTable";
import { getDriverSFEETransactions } from "../../../Services/Driver.service";
import { showAlert } from "../../../Services/Shared.service";
import DataTable from "react-data-table-component";
import moment from "moment";
import { Spinner } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";


const DriverSFEEDetails = ({driverId}) => {
  const [transactionsData, setTransactionsData] = useState([]);
  const [pagination, setPagination] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [loader, setLoader] = useState(false);
  const { mix_background_layout } = useContext(CustomizerContext);

  const onChangePage = (page) => {
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  const fetchSFEETransactions = () => {
    setLoader(true);
    const obj = {
      driverId: Number(driverId),
      page: pagination.toString(),
      size: rowsPerPage.toString(),
    };

    getDriverSFEETransactions(obj)
      .then((result) => {
        setLoader(false);
        if (result.data) {
            
          const processData = result.data.driverWalletTransactionsList
          
          .map(
            (element, index) => {
              return {
                amount: element.Amount ? element.Amount : "-",
                date_time: element.CreatedOn
                  ? moment(new Date(element.CreatedOn)).format(
                      "DD MMM YYYY HH:mm"
                    )
                  : "-",
               
                PaymentStatus: element.PaymentStatus 
                  ? element.PaymentStatus
                  : "-",
              };
            }
          );
          setTransactionsData(processData);
          setPaginationTotalRows(result.data.count);
          console.log("process data",processData)
        }
      })
      .catch((err) => {
        setLoader(false);
        showAlert("error", "Something went wrong");
      });
  };

  useEffect(() => {
    fetchSFEETransactions();
}, [pagination, rowsPerPage]);

  return (
    <Fragment>
            <div className="table-responsive driver-wallet-table">
                <DataTable
                    columns={sFEEColumns}
                    data={transactionsData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={'50vh'}
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    paginationServer
                    pagination
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "50vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>
        </Fragment>
  );
};

export default DriverSFEEDetails;